import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTableDataSourcePageEvent } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { AuthorDataModel, GetAllAuthorsModel } from 'src/app/models/get-all-authors.model';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

export interface DisplayColumn {
  name: string;
  property: string;
  visible: boolean;
  isModelProperty: boolean
}

@Component({
  selector: 'fury-authors-list',
  templateUrl: './authors-list.component.html',
  styleUrls: ['./authors-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AuthorsListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  filterValue: string = '';
  authorList: any;
  imageendpoint: any;
  dataSource: MatTableDataSource<AuthorDataModel> = new MatTableDataSource<AuthorDataModel>();
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  paginator: any
  searchBy: string = 'fullName';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  @Input() displayedColumns: DisplayColumn[] = [
    { name: 'Image', property: 'profilePicture', visible: true, isModelProperty: false },
    { name: 'Name', property: 'fullName', visible: true, isModelProperty: true },
    { name: 'Designation', property: 'designation', visible: true, isModelProperty: true },
    { name: 'Description', property: 'description', visible: true, isModelProperty: false },
    { name: 'Action', property: 'actions', visible: true, isModelProperty: false },
  ];
  searchedKeyword!: string;

  constructor(
    private api: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
  ) {
    this.imageendpoint = '';
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;  
      this.searchBy = res.searchBy ? res.searchBy : 'fullName';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
    });
  }

  get visibleColumns() {
    return this.displayedColumns.filter((column: DisplayColumn) => column.visible).map((column: DisplayColumn) => column.property);
  }
  ngOnInit(): void {
    this.filterValue = 'Authors';
    this.getauthorList();
  }
  getauthorList() {
    this.api.get(`admin/author/get-all-authors?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any) => {
      if (res.body) {
        res.body.authors.data.map((item: any) => {
          if (item.description.length > 50) {
            item.description = item.description.slice(0, 50) + '...';
          } if (item.fullName.length > 25) {
            item.fullName = item.fullName.slice(0, 25) + '...';
          }
          return item;
        });
        this.authorList = res.body.authors.data;
        this.dataSource = new MatTableDataSource(this.authorList);
        this.cdr.detectChanges();
        this.dataSource.paginator = this.paginator;
        this.totalCount = res.body.authors.total;
      } else {
      }
    });
  }
  openDialog(type: string, ID: string) {
    let customwidth;
    if (type === 'delete') { customwidth = '500px' }
    const dialogref = this.dialog.open(ContentActionComponent, {
      width: customwidth,
      data: { type, ID }
    });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.delete(`admin/author/delete-author/${ID}`).subscribe((del: any) => {
          if (del.body) {
            this.api.alert(del.body.message, ErrorType.Success);
            this.getauthorList();
          }
        }, err => {
          if (err) {
            this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    } else {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
      this.router.navigateByUrl(`/homeowner/authors/authors-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getauthorList();
    }
  }

  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/homeowner/authors/authors-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getauthorList();
  };

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'Full Name', value: 'fullName'},
    {title: 'Designation', value: 'designation'},
    {title: 'Description', value: 'description'},
    // {title: 'Linkedin Url', value: 'linkedinUrl'}
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/homeowner/authors/authors-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getauthorList();
  }


}
